import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useExplorerStore } from "../../stores/explorerStore";
import { ROUTES_NAMES } from "../../components/routes";

/** Legacy /explorador/livestreams/audiencia: open the Livestreams "Mapa de audiencia" tab. */
const LivestreamsHeatmapRedirect: React.FC = () => {
  const navigate = useNavigate();
  const hasRehydrated = useExplorerStore((s) => s._hasRehydrated);
  const setLivestreamViewMode = useExplorerStore((s) => s.setLivestreamViewMode);

  useEffect(() => {
    if (!hasRehydrated) return;
    setLivestreamViewMode("heatmap");
    navigate(ROUTES_NAMES.EXPLORER_LIVESTREAMS_LIST, { replace: true });
  }, [hasRehydrated, setLivestreamViewMode, navigate]);

  return null;
};

export default LivestreamsHeatmapRedirect;
